#import "~/graphql/fragments/socialFragment.graphql"

fragment deadlinesPageContent on periodsOverview_Entry {
    title
    description: richTextMinimal
    seo {
        ... socialFragment
    }
    showNewsletterSubscribe
}
